// extracted by mini-css-extract-plugin
export default {"trainAwsPdApplication":"styles_trainAwsPdApplication__8nrIF","iframeContainer":"styles_iframeContainer__A6WFj"};